import { Component } from "react";
import Layout from "../../component/layout";
import NextSeoModule from "../../component/next-seo";
 import Salesforcetemplate from "../../component/course/salesforce";

export default class Salesforceinmumbai extends Component {
 
  render() {
  
    const title = "Salesforce"
    const url= "salesforce"
     const url1 ="-training-in-mumbai"
    const location = "mumbai" 
    const location1="Training in Mumbai"
     return(
      <>
          <NextSeoModule
          title={`${title} ${location1} - learnsoft.org`}
            description={`Boost your career with Salesforce ${location1}. Learn from industry experts, master the Salesforce platform, and get certified with our comprehensive Salesforce training program. Enroll now for a successful future.`}
            url={`${location}/${url}${url1}`}
           img={`course/${url}.webp`}
             keyword={`${title} training in ${location}, ${title} certification in ${location}, Online ${title}  Training in ${location}, ${title} Online Training in ${location}, ${title} Syllabus, ${title} course in ${location}, ${title} classes in ${location}, ${title} institute in ${location}, Best ${title} training institute in ${location}, ${title} training and certification in ${location}, Best ${title} training in ${location}, ${title} coaching in ${location}, ${title} training center in ${location}, ${title} training provider in ${location}`}
          />
        <Layout navbarBackgroundColor="#281E1E">
          <Salesforcetemplate url1={url1} title={title} url={url} relatedlocation={location} location={location} location1={location1} />
         </Layout>
      </>
    );
  }
}
